import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app';
import reportWebVitals from './reportWebVitals';
import KeycloakAuthenticationProvider from "./provider/authentication/keycloak.authentication.provider";
import 'antd/dist/reset.css';
import {HelmetProvider} from 'react-helmet-async';

const root = ReactDOM.createRoot(
        document.getElementById('root') as HTMLElement
);
root.render(
        <HelmetProvider>
            <KeycloakAuthenticationProvider>
                <App/>
            </KeycloakAuthenticationProvider>
        </HelmetProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
